import Pages from './Pages';
import { SetupApiInterceptor } from './utils/http';
import Header from './Common/header'
import { initFirebase } from './Pages/StashKar/firebase';

SetupApiInterceptor();

function App() {
  initFirebase();
  return (
    <div className='App'>
      <Pages />
    </div>
  );
}

export default App;
